import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import { useDebounceFn } from '@vueuse/core'
import {
  CenterCoordinates,
  EventMapDB,
  EventMapPeriod,
  EventMapSearchParams,
  mapApi,
  MapCornersCoordinates,
} from '@/enitites/map'
import { EventPreviewCompactCard } from '@/features/event-card'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventsListMap',
  props: {
    centerCoordinates: null,
    visibleMapCoordinates: null,
    searchParams: null
  },
  emits: ["events", "changed-tab", "hovered-event", "un-hovered-event"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'events', value: EventMapDB[]): void
  (e: 'changed-tab', value: { name: EventMapPeriod; amount: number }): void
  (e: 'hovered-event', value: EventMapDB): void
  (e: 'un-hovered-event'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  centerCoordinates: CenterCoordinates
  visibleMapCoordinates?: MapCornersCoordinates
  searchParams: EventMapSearchParams
};





const tabsInfo = ref<Record<EventMapPeriod, number>>({
  now: 0,
  future: 0,
  past: 0,
})
const tabsList = computed((): { name: EventMapPeriod; amount: number }[] => [
  { name: 'now', amount: tabsInfo.value.now },
  { name: 'future', amount: tabsInfo.value.future },
  { name: 'past', amount: tabsInfo.value.past },
])

const events = ref<EventMapDB[] | []>([])
const loading = ref(false)

async function getCoordinatesOfAddresses(value: EventMapDB[]) {
  if (!google) return
  events.value = value
  const geocoder = new google.maps.Geocoder()
  const promises = events.value.map(
    (event) =>
      new Promise<EventMapDB>((resolve) => {
        geocoder.geocode(
          { address: event.locationAddress },
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
            if (status === 'OK') {
              resolve({
                ...event,
                coordinates: {
                  lat: results[0].geometry.location.lat(),
                  lng: results[0].geometry.location.lng(),
                },
              })
            } else {
              resolve(event)
            }
          }
        )
      })
  )
  const eventsWithCoordinates = await Promise.all(promises)
  emit('events', eventsWithCoordinates)
}

const selectedTab = ref<null | number>(null)
const isNeedSelectTab = ref(true)

function selectTabWithEvents() {
  if (!isNeedSelectTab.value) return
  // eslint-disable-next-line no-restricted-syntax
  for (const key in tabsInfo.value) {
    if (tabsInfo.value[key as EventMapPeriod]) {
      selectedTab.value = Object.keys(tabsInfo.value).indexOf(key)
      emit('changed-tab', tabsList.value[selectedTab.value])
      isNeedSelectTab.value = false
      break
    }
  }
}

async function getEventsMap() {
  if (!props.visibleMapCoordinates) return
  loading.value = true
  const data = await mapApi.getMapEvents({
    ...props.searchParams,
    userCoords: [props.centerCoordinates.lat, props.centerCoordinates.lng],
    visibleMap: props.visibleMapCoordinates,
  })

  if (!data) {
    events.value = []
    loading.value = false
    return
  }
  const { events: dataEvents, stats } = data
  events.value = dataEvents
  tabsInfo.value = {
    now: stats.now,
    future: stats.future,
    past: stats.past,
  }

  selectTabWithEvents()
  await getCoordinatesOfAddresses(events.value)
  loading.value = false

  for (let i = 0; i < events.value.length; i++) {
    const event = events.value[i]
    if (event.coordinates) {
      emit('events', events.value)
      break
    }
  }
}

const debouncedGetEventsMap = useDebounceFn(getEventsMap, 750)
watch(
  [() => props.searchParams, () => props.centerCoordinates, () => props.visibleMapCoordinates],
  () => {
    debouncedGetEventsMap()
  },
  { deep: true }
)

return { __sfc: true,props, emit, tabsInfo, tabsList, events, loading, getCoordinatesOfAddresses, selectedTab, isNeedSelectTab, selectTabWithEvents, getEventsMap, debouncedGetEventsMap, EventPreviewCompactCard }
}

})